import Cookies from 'js-cookie'
import { useRoute, useRouter } from 'vue-router'
import { watch, onMounted } from 'vue'

export const saveRedirectUrl = (url: string, isDev: boolean = false) => {
  const domain = isDev ? 'lexicomb.loc' : 'lexicomb.com'

  // console.log('[saveRedirectUrl] Setting cookie:', { url, domain, isDev })

  Cookies.remove('redirect_url', { path: '/', domain: 'lexicomb.loc' })
  Cookies.remove('redirect_url', { path: '/', domain: 'lexicomb.com' })
  Cookies.remove('redirect_url', { path: '/', domain: 'dev.lexicomb.com' })
  Cookies.remove('redirect_url', { path: '/' })

  Cookies.set('redirect_url', url, {
    path: '/',
    domain,
  })

  let cookieValue = Cookies.get('redirect_url')
  if (!cookieValue && typeof window !== 'undefined') {
    Cookies.set('redirect_url', url, { path: '/' })
    cookieValue = Cookies.get('redirect_url')
  }
  // console.log('[saveRedirectUrl] Cookie set, current value:', cookieValue)

  if (!cookieValue) {
    console.warn(
      '[saveRedirectUrl] WARNING: Cookie was not set! Check browser console Application/Cookies tab'
    )
  }
}

export const clearRedirectUrl = () => {
  Cookies.remove('redirect_url', { path: '/', domain: 'lexicomb.loc' })
  Cookies.remove('redirect_url', { path: '/', domain: 'lexicomb.com' })
  Cookies.remove('redirect_url', { path: '/', domain: 'dev.lexicomb.com' })
  Cookies.remove('redirect_url', { path: '/' })
}

export const useSaveCurrentUrl = (
  appDomain: string,
  isDev: boolean = false
) => {
  const route = useRoute()
  const router = useRouter()

  const saveCurrentRoute = () => {
    const urlWithDomain = `${appDomain}${route.fullPath}`
    // console.log('[useSaveCurrentUrl] Saving URL:', {
    //   appDomain,
    //   fullPath: route.fullPath,
    //   urlWithDomain,
    //   isDev,
    // })
    saveRedirectUrl(urlWithDomain, isDev)
  }

  onMounted(async () => {
    await router.isReady()
    console.log('[useSaveCurrentUrl] Router ready, saving current route')
    saveCurrentRoute()
  })

  watch(
    () => route.fullPath,
    (newPath, oldPath) => {
      console.log('[useSaveCurrentUrl] Route changed:', { oldPath, newPath })
      saveCurrentRoute()
    }
  )

  return { saveCurrentRoute }
}
